"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractDefaultValue = exports.extractVariables = void 0;
var React = __importStar(require("react"));
var extractVariables = function (nodes) {
    if (nodes === undefined || nodes === null) {
        return {};
    }
    if (nodes instanceof Array) {
        return nodes
            .map(function (node) { return (0, exports.extractVariables)(node); })
            .reduce(function (memo, values) {
            return __assign(__assign({}, memo), values);
        }, {});
    }
    if (React.isValidElement(nodes)) {
        return (0, exports.extractVariables)(nodes.props.children);
    }
    if (typeof nodes === 'object') {
        return Object.keys(nodes).reduce(function (memo, key) {
            var _a;
            var value = nodes[key];
            if (typeof value === 'string' || typeof value === 'number') {
                return __assign(__assign({}, memo), (_a = {}, _a[key] = value, _a));
            }
            return memo;
        }, {});
    }
    return {};
};
exports.extractVariables = extractVariables;
var extractDefaultValue = function (nodes, idx) {
    if (idx === void 0) { idx = 0; }
    if (nodes === undefined || nodes === null) {
        return '';
    }
    if (typeof nodes === 'string' || typeof nodes === 'number' || typeof nodes === 'boolean') {
        return nodes.toString();
    }
    if (React.isValidElement(nodes)) {
        return "<".concat(idx, ">").concat((0, exports.extractDefaultValue)(nodes.props.children), "</").concat(idx, ">");
    }
    if (nodes instanceof Array) {
        return nodes.map(function (node, idx) { return (0, exports.extractDefaultValue)(node, idx); }).join('');
    }
    if (typeof nodes === 'object') {
        return "{".concat(Object.keys(nodes).join(' '), "}");
    }
    return '';
};
exports.extractDefaultValue = extractDefaultValue;
